/**
 * Canonical initial state for the modalDialog Vuex module.
 *
 * Extracted so `store/modalDialog.js` `state()` has a single source of truth
 * that carries over verbatim to the Pinia store after the Nuxt 3 migration
 * (where `$reset()` restores exactly this object).
 *
 * ⚠️ Migration note — partial reset: every value `clearModalDialog` resets
 * matches these defaults, EXCEPT that `clearModalDialog` intentionally does NOT
 * reset `didClickOk` or `isProcessing` (they are managed around the OK-click
 * lifecycle). A blanket `$reset()` WOULD reset them to `false` — confirm that is
 * acceptable before replacing the clear-chain with `$reset()`.
 */
export const modalDialogDefaults = {
  showModalDialog: false,
  title: null,
  subtitle: null,
  message: null,
  dialogStyle: null,
  doHideCancelButton: false,
  okShouldActLikeCancel: false,
  okButtonCaptionVerbOverride: null,
  cancelButtonCaptionVerbOverride: null,
  doSkipVerification: false,
  okButtonWidth: null,
  didClickOk: false,
  isProcessing: false,
  onOkCallback: undefined,
  onOkCallbackData: undefined,
}
